import { TransformWithLVS } from '@goparrot/common';
export function ToLowerCase() {
    return TransformWithLVS(({ value }) => (typeof value === 'string' ? value.toLowerCase() : value));
}
//# sourceMappingURL=ToLowerCase.js.map